import React from "react";

const AllAppointmentsModal = ({
  open,
  onClose,
  appointments = [],
    statusChipClasses,
  formatTime,
  // Optional: open the Purpose-of-Visit editor. Receives the clicked
  // appointment's index so the editor can focus that appointment.
  onEditPurpose,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg w-[420px] max-h-[70vh] p-4 flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center mb-3">
          <h3 className="font-inter font-semibold text-[14px]">
            All Appointments
          </h3>
          <button
            onClick={onClose}
            className="text-[#6B7280] text-[14px] font-medium"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        {/* {onEditPurpose && (
          <div className="text-[11px] text-[#6B7280] font-inter mb-2">
            Tap an appointment to change its type of visit
          </div>
        )} */}
        <div className="flex flex-wrap gap-2 overflow-y-auto custom-scrollbar">
          {appointments.map((appt, index) => (
            <button
              type="button"
              key={index}
              onClick={
                onEditPurpose ? () => onEditPurpose(index) : undefined
              }
className={`
    h-[20px] px-1.5 py-[2px] bg-[#D1E1FF] font-inter border-[1.5px] rounded-[10px] text-[12px] font-medium
    ${onEditPurpose ? "cursor-pointer hover:opacity-80" : ""}
    ${statusChipClasses(
                   appt.visit_confirmation,
                    Boolean(appt.visit_confirmation)
                  )
    }
  `}
            >
              <span className="truncate max-w-[220px]">
                {appt?.purpose || "-"}
              </span>
              {" - "}
              <span className="text-[10px] ">
                {formatTime(appt?.starttime)}
              </span>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-1 rounded-md text-[12px] font-inter bg-[#1D4ED8] text-white"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllAppointmentsModal;
